"use client";

/**
 * /ios — the iPhone & iPad app's home (Gordon 2026-10-30: "make a page
 * breakinbread.com/ios … prepare to download the ios app from the app store"
 * + "first in test mode link for a few founders"). Until the App Store listing
 * exists: founders test through TestFlight invites, everyone else uses BB from
 * the iPhone home screen. When the app ships, set APP_STORE_URL.
 */

import Link from "next/link";
import { useTranslations } from "next-intl";
import { Apple, FlaskConical, Share, SquarePlus, Smartphone } from "lucide-react";
import { Button } from "@/components/ui/button";

/** Set when the App Store listing is live. */
const APP_STORE_URL = "";
const TESTFLIGHT_APP_URL = "https://apps.apple.com/app/testflight/id899247664";

export default function IosPage() {
  const t = useTranslations("iosApp");
  return (
    <div className="w-full px-page py-8">
      <div className="max-w-3xl space-y-10">
        <header className="space-y-3">
          <p className="inline-flex items-center gap-2 rounded-full bg-primary px-3 py-1 text-xs font-bold uppercase tracking-widest text-primary-foreground">
            <Apple className="h-3.5 w-3.5" aria-hidden /> {APP_STORE_URL ? t("available") : t("comingSoon")}
          </p>
          <h1 className="text-3xl sm:text-5xl font-bold">{t("title")}</h1>
          <p className="text-lg text-muted-foreground">{t("intro")}</p>
          {APP_STORE_URL ? (
            <Button asChild size="lg" className="gap-2"><a href={APP_STORE_URL}><Apple className="h-5 w-5" /> {t("download")}</a></Button>
          ) : (
            <Button size="lg" className="gap-2" disabled><Apple className="h-5 w-5" /> {t("downloadSoon")}</Button>
          )}
        </header>

        <section className="space-y-3 rounded-2xl border border-border p-5">
          <h2 className="flex items-center gap-2 text-xl font-semibold"><FlaskConical className="h-5 w-5 text-primary" /> {t("foundersTitle")}</h2>
          <p className="text-muted-foreground">{t("foundersBody")}</p>
          <ol className="list-decimal space-y-1 pl-5 text-sm">
            <li>{t("founders1")}</li>
            <li>{t("founders2")}</li>
            <li>{t("founders3")}</li>
          </ol>
          <Button asChild variant="outline" className="gap-2"><a href={TESTFLIGHT_APP_URL} target="_blank" rel="noopener noreferrer"><FlaskConical className="h-4 w-4" /> {t("getTestFlight")}</a></Button>
        </section>

        <section className="space-y-3 rounded-2xl border border-border p-5">
          <h2 className="flex items-center gap-2 text-xl font-semibold"><Smartphone className="h-5 w-5 text-primary" /> {t("nowTitle")}</h2>
          <p className="text-muted-foreground">{t("nowBody")}</p>
          <ol className="space-y-2 text-sm">
            <li className="flex items-center gap-2"><Share className="h-4 w-4 shrink-0" aria-hidden /> {t("now1")}</li>
            <li className="flex items-center gap-2"><SquarePlus className="h-4 w-4 shrink-0" aria-hidden /> {t("now2")}</li>
            <li className="flex items-center gap-2"><Smartphone className="h-4 w-4 shrink-0" aria-hidden /> {t("now3")}</li>
          </ol>
          <Button asChild><Link href="/home">{t("openBB")}</Link></Button>
        </section>
      </div>
    </div>
  );
}
